
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ambulante-presenta",
      function () {
        return require("private-next-pages/ambulante-presenta/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ambulante-presenta"])
      });
    }
  